import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';

/**
 * Operating-System banner — surfaces the V2 B2B story above the V1
 * consumer service pages. Routes incoming long-tail SEO traffic toward
 * the six monetizable product suites without touching the V1 family
 * copy underneath (preserves SEO equity, adds upmarket conversion).
 *
 * Used on /services and /services/:slug.
 */
export const OperatingSystemBanner = () => {
  return (
    <section className="bg-cn-primary text-white" data-testid="os-banner">
      <div className="cn-container py-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <div className="flex items-center gap-2.5 text-sm">
          <Sparkles className="w-4 h-4 text-cn-accent flex-shrink-0" />
          <span>
            <span className="font-semibold">For hospitals, agencies &amp; clinicians:</span>{' '}
            CaraLoom is the AI Operating System for the Post-Acute Care Ecosystem — six product suites.
          </span>
        </div>
        <Link
          to="/suites/referrals"
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-cn-accent hover:text-white whitespace-nowrap"
          data-testid="os-banner-cta"
        >
          Explore product suites <ArrowRight className="w-3.5 h-3.5" />
        </Link>
      </div>
    </section>
  );
};

export default OperatingSystemBanner;
